module.exports = __webpack_public_path__ + "img/Welcome02.0e259629.svg";